import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

export default async function getLotById(lotId, callback) {
	firebaseRef
		.database()
		.ref('/kavtek_lots/' + PROJECT_CODE.projectCode)
		.orderByChild('lotId')
		.equalTo(lotId)
		.once('value', (snapshot) => {
			var lotParent = snapshot.val();

			var lotParentKey = Object.keys(lotParent)[0];

			callback(lotParent[lotParentKey]);
		});
}
